export const UTILITY_DOCK = {
  TAB: {
    NOTIFICATIONS: 'notifications',
    INBOX: 'inbox',
  },
  TASKS_MODE: {
    INBOX: 'inbox',
    ASSIGNED: 'assigned',
  },
  NOTIFICATION_SNOOZE_PRESET: {
    TEN_MINUTES: '10m',
    ONE_HOUR: '1h',
    TOMORROW: 'tomorrow',
  },
  INBOX_TASK_FILTER: {
    ALL: 'all',
    TODAY: 'today',
    OVERDUE: 'overdue',
    HIGH: 'high',
  },
  REORDER_DIRECTION: {
    UP: 'up',
    DOWN: 'down',
  },
} as const;

export type UtilityDockTab = (typeof UTILITY_DOCK.TAB)[keyof typeof UTILITY_DOCK.TAB];
export type UtilityDockTasksMode =
  (typeof UTILITY_DOCK.TASKS_MODE)[keyof typeof UTILITY_DOCK.TASKS_MODE];
export type NotificationSnoozePreset =
  (typeof UTILITY_DOCK.NOTIFICATION_SNOOZE_PRESET)[keyof typeof UTILITY_DOCK.NOTIFICATION_SNOOZE_PRESET];
export type InboxTaskFilterUiValue =
  (typeof UTILITY_DOCK.INBOX_TASK_FILTER)[keyof typeof UTILITY_DOCK.INBOX_TASK_FILTER];
export type ReorderDirection =
  (typeof UTILITY_DOCK.REORDER_DIRECTION)[keyof typeof UTILITY_DOCK.REORDER_DIRECTION];
